import React from "react";
import { StyleSheet } from "react-native";
import Dialog from "@components/molecules/dialog/Dialog";

// 通知の種類に応じた詳細を表示する。ラベルや価格の表示文言は backend から受け取る。
// 別フィールドで返される PushCampaignMessage も、このモーダルで表示する。
export type NotificationInfoModalData =
  | {
      readonly __typename: "CancelCampaignInfoModal";
      readonly campaignName: string;
      readonly subtitle: string;
      readonly canceledAt: string;
      readonly reason: string | null;
      readonly reasonLabel: string;
    }
  | {
      readonly __typename: "CandidatePriceChangedInfoModal";
      readonly campaignName: string;
      readonly subtitle: string;
      readonly changedAt: string;
      readonly oldPrice: number;
      readonly newPrice: number;
      readonly priceText: string;
      readonly detailButtonLabel: string;
    }
  | {
      readonly __typename: "ReRecruitCampaignInfoModal";
      readonly campaignName: string;
      readonly reRecruitAt: string;
      readonly content: string;
      readonly reason: string | null;
      readonly reasonLabel: string;
    }
  | {
      readonly __typename: "PushCampaignMessage";
      readonly title: string;
      readonly body: string;
    };

type Props = {
  data: NotificationInfoModalData;
  onClose: () => void;
  // candidate_price_changed モーダルでのみ詳細導線を出すために使う
  onPressCampaignDetail?: () => void;
};

export default function NotificationInfoModal({
  data,
  onClose,
  onPressCampaignDetail,
}: Props): JSX.Element {
  switch (data.__typename) {
    case "CancelCampaignInfoModal": {
      const reason = data.reason ?? "";
      return (
        <Dialog
          buttons={[{ title: "閉じる", type: "white" }]}
          customStyle={{ messageStyle: styles.title }}
          message={`${data.canceledAt} ${data.campaignName}`}
          onClose={onClose}
          subline={`${data.subtitle}\n\n${data.reasonLabel}\n${reason}`}
        />
      );
    }
    case "CandidatePriceChangedInfoModal": {
      const buttons: { title: string; type: "white" | "blueGradient"; onPress?: () => void }[] = [
        { title: "閉じる", type: "white" },
      ];
      if (onPressCampaignDetail != null) {
        buttons.push({
          title: data.detailButtonLabel,
          type: "blueGradient",
          onPress: onPressCampaignDetail,
        });
      }
      return (
        <Dialog
          buttons={buttons}
          customStyle={{ messageStyle: styles.title }}
          message={`${data.changedAt} ${data.campaignName}`}
          onClose={onClose}
          subline={`${data.subtitle}\n\n${data.priceText}`}
        />
      );
    }
    case "ReRecruitCampaignInfoModal": {
      const reason = data.reason ?? "";
      return (
        <Dialog
          buttons={[{ title: "閉じる", type: "white" }]}
          customStyle={{ messageStyle: styles.title }}
          message={`${data.reRecruitAt} ${data.campaignName}`}
          onClose={onClose}
          subline={`${data.content}\n\n${data.reasonLabel}\n${reason}`}
        />
      );
    }
    case "PushCampaignMessage":
      return (
        <Dialog
          buttons={[{ title: "閉じる", type: "white" }]}
          customStyle={{ messageStyle: styles.title }}
          message={data.title}
          onClose={onClose}
          subline={data.body}
        />
      );
    default: {
      // 将来 union が増えた場合の exhaustiveness 担保
      const _exhaustive: never = data;
      return _exhaustive;
    }
  }
}

const styles = StyleSheet.create({
  title: {
    textAlign: "left",
  },
});
